import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  UncontrolledAlert
} from "reactstrap";
import { Spinner } from "./Spinner";

class ConfirmationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    const {
      message,
      action,
      isOpen,
      showModal,
      item,
      error,
      actionState,
      mealPlanError
    } = this.props;
    const modalError = error || (actionState && actionState.error);
    return (
      <div>
        <Modal
          isOpen={isOpen || this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <ModalBody>
            {modalError ? (
              <UncontrolledAlert color="danger">
                {modalError.message}
              </UncontrolledAlert>
            ) :null}
            {mealPlanError && !mealPlanError.errors ? <UncontrolledAlert color="danger">{mealPlanError.message}</UncontrolledAlert> : null}
                {mealPlanError && mealPlanError.errors ? (
                    <UncontrolledAlert color="danger">
                        {mealPlanError.errors.map((error, index) => (
                            <p key={index}>{error.message}</p>
                        ))}
                    </UncontrolledAlert>
                ) : null}
            {message || "Are you sure you want to delete?"}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => action(item)}>
              {actionState && actionState.sending ? <Spinner /> : "Yes"}
              
            </Button>{" "}
            <Button color="secondary" onClick={() => showModal(item)}>
              No
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ConfirmationModal;
